export default window._cmsContent['whd/eligibility-proof']